








import Component, { mixins } from "vue-class-component";
import AxiosMixin from "../../mixins/axiosMixin";
import { Emit } from "vue-property-decorator";
import Cookies from "js-cookie";

@Component
export default class MockToken extends mixins(AxiosMixin) {
  authOnetime() {
    //これはiBowで叩く想定
    this.postJsonCheck(
      window.base_url + "/auth/onetime",
      {
        ibow_url: "https://customer-7378.e-ibow.jp/",
        user_id: "ibowadmin4",
        user_name: "テストユーザー",
        password: "100"
      },
      res => {
        //URLにonetime_tokenが入っている場合にその値を使ってどこかで叩く想定
        this.postJsonCheck(
          window.base_url + "/auth/fromonetime",
          { one_time_token: res.data.one_time_token },
          res2 => {
            window.token = res2.data.token;
            Cookies.set("token", window.token);
            window.reftoken = res2.data.ref_token;
            Cookies.set("reftoken", window.reftoken);
            window.user_name = res2.data.user_name;
            Cookies.set("user_name", window.user_name);
            this.token();
          }
        );
      }
    );
  }

  authOnetimeV2() {
    //dev01-エイブル訪問看護ステーション
    this.postJsonCheck(
      window.base_url + "/auth/onetime/v2",
      {
        ibow_url: "https://customer-7378.e-ibow.jp/",
        user_id: "ibowadmin4",
        user_name: "テストユーザー",
        password: "100",
        agreement_id: "81",
        office_ibow_id: "8",
        office_ibow_unique_id: "288",
        office_name: "エイブル訪問看護ステーション(V2)",
        type: "1",
		// auth_id: "10",
		// receipt_agency_div: "1",
		// receipt_agency_ibowrec_button: "1"
      },
      res => {
        //URLにonetime_tokenが入っている場合にその値を使ってどこかで叩く想定
        this.postJsonCheck(
          window.base_url + "/auth/fromonetime",
          { one_time_token: res.data.one_time_token },
          res2 => {
            window.token = res2.data.token;
            Cookies.set("token", window.token);
            window.reftoken = res2.data.ref_token;
            Cookies.set("reftoken", window.reftoken);
            window.user_name = res2.data.user_name;
            Cookies.set("user_name", window.user_name);
            this.token();
            window.button_ctrl = (res2.data.receipt_agency_ibowrec_button == "1");
            Cookies.set("button_ctrl", res2.data.receipt_agency_ibowrec_button);
          }
        );
      }
    );
  }

  @Emit()
  private token() {
    return;
  }
}
